import 'bootstrap';
import AOS from 'aos';
import 'slick-carousel';

const $ = require('jquery');

const $root = $('html, body');
global.$ = $;
global.jQuery = $;

require('popper.js');
require('jquery.easing');

document.addEventListener('DOMContentLoaded', () => {
	AOS.init({
		duration: 1200,
	});

	// smooth scrolling, disabled for accordion links
	$('a[href^="#"]:not([data-toggle])').on('click', function smoothScroll() {
		const href = $.attr(this, 'href');
		$root.animate({
			scrollTop: $(href).offset().top,
		}, 500, () => {
			window.location.hash = href;
		});

		return false;
	});

	$('.carousel-items').slick({
		infinite: true,
		lazyLoad: 'ondemand',
		slidesToShow: 3,
		slidesToScroll: 1,
		speed: 400,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
});
